<div class="list-page" style="max-width: 1200px">
  <div class="ylaosan-kontrollit">
    <div class="lisaa-nappula-container">
      <button mat-button (click)="lisaa()" type="button" class="primarybutton mat-elevation-z4">
        <mat-icon>add</mat-icon>
        {{ 'tositteet.maksukortit.lisaa' | translate | async }}
      </button>
    </div>
  </div>

  @if (tilaObservable | async; as tila) {
    <div style="position: relative">
      @if (tila.virhe) {
        <div class="tyhja-tila">
          <div>{{ 'tositteet.maksukortit.haku-epaonnistui' | translate | async }}</div>
          <button mat-button type="button" class="secondarybutton" (click)="yritaUudelleen()">{{ 'tositteet.maksukortit.yrita-uudelleen' | translate | async }}</button>
        </div>
      } @else if (!tila.lataa && tila.kortit.length === 0) {
        <div class="tyhja-tila">
          <div>{{ 'tositteet.maksukortit.tyhja-selite' | translate | async }}</div>
          <div class="gray-text">{{ 'tositteet.maksukortit.tyhja-kehotus' | translate | async }}</div>
        </div>
      } @else {
        <mat-table matSort [dataSource]="tila.kortit" [matSortDisableClear]="true" (matSortChange)="jarjesta($event)" style="min-height: 94px">
          <ng-container matColumnDef="kortinNumero">
            <mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'tositteet.maksukortit.kortin-numero' | translate | async }} </mat-header-cell>
            <mat-cell *matCellDef="let row"> {{ row.kortinNumero }} </mat-cell>
          </ng-container>

          <ng-container matColumnDef="nimi">
            <mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'tositteet.maksukortit.nimi' | translate | async }} </mat-header-cell>
            <mat-cell *matCellDef="let row"> {{ row.nimi }} </mat-cell>
          </ng-container>

          <ng-container matColumnDef="maksutapa">
            <mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'tositteet.maksukortit.maksutapa' | translate | async }} </mat-header-cell>
            <mat-cell *matCellDef="let row"> {{ row.maksutapaNimi }} </mat-cell>
          </ng-container>

          <ng-container matColumnDef="toiminnot">
            <mat-header-cell *matHeaderCellDef></mat-header-cell>
            <mat-cell *matCellDef="let row">
              <button mat-icon-button type="button" (click)="poista(row)" [attr.aria-label]="'tositteet.maksukortit.poista-otsikko' | translate | async">
                <mat-icon>delete</mat-icon>
              </button>
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="propertiesToDisplay"></mat-header-row>
          <mat-row *matRowDef="let row; columns: propertiesToDisplay"></mat-row>
        </mat-table>
      }
      <div lemon-loading [show]="tila.lataa"></div>
    </div>
  }
</div>
